<template>
  <div class="session-modal">
    <s-modal
      v-model="visibleProxy"
      hide-footer
      @hidden="closeModal"
    >
      <div
        class="session-modal__title"
        slot="modal-title"
      >
        {{ $t('expired-session.your-session-expired') }}
      </div>
      <b-container>
        <b-row
          class="pt-4 pb-5"
          align-h="center"
        >
          <img
            alt="Stopwatch"
            src="/static/imgs/stopwatch.svg"
          />
        </b-row>
        <b-row align-h="center">
          <b-button
            variant="primary"
            @click="closeModal"
          >
            {{ $t('expired-session.sign-in-again') }}
          </b-button>
        </b-row>
        <b-row
          class="pt-4"
          align-h="center"
        >
          <p>
            {{ $t('expired-session.why-did-my-session-expired') }}
            <i
              class="ml-1 fas fa-info-circle session-modal__hint"
              aria-hidden="true"
              v-b-tooltip="sessionExpiredOptions"
            />
          </p>
        </b-row>
      </b-container>
    </s-modal>
  </div>
</template>

<script>

export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    visibleProxy: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      },
    },
    sessionExpiredOptions() {
      return {
        title: `${this.$t('expired-session.expiration-hint')}.`,
        trigger: 'hover',
        placement: 'right',
        boundary: 'viewport',
      };
    },
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"

.session-modal
  ::v-deep .modal-title
    width: 100%
  &__title
    text-transform: initial
    text-align: center
  &__hint
    color: var(--color-info)
</style>
